import React from 'react';

const SortSVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='14'
      viewBox='0 0 15 14'
      fill='none'
      className={className}
      onClick={onClick}
    >
      <path
        d='M12.7399 9.33334L10.4066 11.6667L8.07324 9.33334'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.4072 11.6667V2.33334'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.24023 4.66668L4.57357 2.33334L6.9069 4.66668'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.57324 2.33334V11.6667'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default SortSVG;
